export const WORKFLOW_DATA_SOURCES = 'workflow_data_sources';
export const ACTION_OUTPUTS = 'action_outputs';
export const ENROLLED_OBJECT = 'enrolled_object';
export const FETCHED_OBJECTS = 'fetched_objects';
export const ENROLLMENT_EVENTS = 'enrollment_events';
export const ENROLLMENT_DATASET = 'enrollment_dataset';
export const DATA_COORDINATE_PROPERTY = 'hs_data_coordinate';